import React from "react";

export const Footer = () => (
  <div className="py-2 text-center text-light bg-info">
    <span>
      Powered By :
      {" "}
      <a href="https://www.linkedin.com/in/ghifari-raihan/" className="text-light">Ghifari Raihan</a>
    </span>
  </div>
);
